module.exports = __webpack_public_path__ + "static/media/covi_can_don_sha.69a14455.png";